import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import heroPhoto from "@/assets/hero-photo.png";
import heroBg from "@/assets/hero-bg.jpg";

const HeroSection = () => {
  return (
    <section className="relative min-h-[85vh] flex items-end overflow-hidden" aria-label="Campaign hero">
      {/* Background Image */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: `url(${heroBg})` }}
        role="img"
        aria-label="Rural marshland boardwalk landscape"
      >
        <div className="absolute inset-0 bg-gradient-to-r from-secondary/95 via-secondary/80 to-secondary/40" />
      </div>

      <div className="container mx-auto px-4 relative z-10 pb-0">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-4 items-end">
          {/* Content */}
          <div className="text-primary-foreground lg:col-span-3 pb-12">
            <p className="font-body text-lg uppercase tracking-widest mb-4 animate-fade-in-up text-campaign-cream/80">
              Conservative Leadership
            </p>
            <h1 className="font-display text-5xl md:text-6xl lg:text-7xl font-bold mb-6 animate-fade-in-up animation-delay-100 text-shadow-lg">
              Matt Bucher
            </h1>
            <p className="font-display text-2xl md:text-3xl italic mb-2 animate-fade-in-up animation-delay-200">
              for State Representative
            </p>
            <p className="font-body text-xl mb-8 animate-fade-in-up animation-delay-200 text-campaign-cream/90">
              33rd District
            </p>
            <p className="font-display text-3xl md:text-4xl font-semibold mb-8 animate-fade-in-up animation-delay-300 text-campaign-cream">
              Standing Up for Rural Communities
            </p>
            <div className="flex flex-col sm:flex-row gap-4 animate-fade-in-up animation-delay-400">
              <Button variant="hero" size="xl" asChild>
                <Link to="/donate">Support the Campaign</Link>
              </Button>
              <Button variant="heroOutline" size="xl" asChild>
                <Link to="/issues">Our Priorities</Link>
              </Button>
            </div>
          </div>

          {/* Candidate Photo */}
          <div className="hidden lg:flex lg:col-span-2 justify-center items-end animate-slide-in-right animation-delay-300">
            <div className="relative">
              {/* Frame behind candidate */}
              <div className="absolute inset-x-4 top-8 bottom-0 border-2 border-campaign-cream/40 bg-primary/30" />
              <img
                src={heroPhoto}
                alt="Matt Bucher, Candidate for State Representative"
                className="relative z-10 max-h-[600px] object-contain drop-shadow-2xl"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
